import { PRODUCT_TYPE_GIFTCARD, PRODUCT_TYPE_GROUPED } from '@bluheadless/ui-logic/src/constants'
import { useConfig } from '@bluheadless/ui-logic/src/providers/config'
import { useProductContext } from '@bluheadless/ui-logic/src/providers/product'
import { KlarnaPlacement } from '../klarna'
import { PaypalPlacement } from '../paypal'
import { Root } from './installments-action.styled'

const InstallmentsAction = ({ ...props }) => {
	const {
		sales: {
			payments: {
				klarna: {
					enabled: klarnaEnabled,
					product: { enabled: klarnaEnabledProduct, placement },
				},
				paypal: {
					enabled: paypalEnabled,
					product: { enabled: paypalEnabledProduct },
				},
			},
		},
	} = useConfig()

	const [
		{
			product: { type },
			prices,
			selectedOptions,
		},
	] = useProductContext()

	return type !== PRODUCT_TYPE_GROUPED &&
		((klarnaEnabled && klarnaEnabledProduct) || (paypalEnabled && paypalEnabledProduct)) ? (
		<Root {...props}>
			{klarnaEnabled && klarnaEnabledProduct ? (
				<KlarnaPlacement
					purchaseAmount={
						type === PRODUCT_TYPE_GIFTCARD
							? selectedOptions.amount || selectedOptions.openAmount || prices.final
							: prices.final
					}
					placementKey={placement}
				/>
			) : null}
			{paypalEnabled && paypalEnabledProduct ? (
				<PaypalPlacement
					// TODO: use base price
					purchaseAmount={
						type === PRODUCT_TYPE_GIFTCARD
							? selectedOptions.amount || selectedOptions.openAmount || prices.final
							: prices.final
					}
				/>
			) : null}
		</Root>
	) : null
}

InstallmentsAction.propTypes = {}

export default InstallmentsAction
